import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = {
  key: 1,
  class: "p-the-page-j01"
}
const _hoisted_5 = {
  class: "p-the-page-j01__body",
  ref: "messageListContainer"
}
const _hoisted_6 = {
  key: 2,
  ref: "loadMoreTrigger",
  class: "load-more-trigger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_LoadingContent = _resolveComponent("LoadingContent")!
  const _component_JMessageArticleList = _resolveComponent("JMessageArticleList")!
  const _component_ThanksPointSearchNotFound = _resolveComponent("ThanksPointSearchNotFound")!
  const _component_TheTemplateJ = _resolveComponent("TheTemplateJ")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheTemplateJ, {
          heading: _ctx.thanksPointName,
          "indicated-item": ['search', 'button'],
          "search-keyword": _ctx.keyword,
          "error-message": _ctx.error,
          onDoSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doSearch($event)))
        }, {
          filter: _withCtx(() => [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterType) = $event)),
              class: "p-message-filter"
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("option", { value: "all" }, "すべて", -1),
              _createElementVNode("option", { value: "unread" }, "未読あり", -1)
            ]), 512), [
              [_vModelSelect, _ctx.filterType]
            ])
          ]),
          contents: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_LoadingContent, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.messageArticleList.length > 0)
                      ? (_openBlock(), _createBlock(_component_JMessageArticleList, {
                          key: 0,
                          "message-article-list": _ctx.messageArticleList,
                          exclude: []
                        }, null, 8, ["message-article-list"]))
                      : (_ctx.keyword)
                        ? (_openBlock(), _createBlock(_component_ThanksPointSearchNotFound, {
                            key: 1,
                            keyword: _ctx.keyword
                          }, null, 8, ["keyword"]))
                        : _createCommentVNode("", true),
                    (_ctx.hasMore)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, null, 512))
                      : _createCommentVNode("", true)
                  ], 512)
                ]))
          ]),
          _: 1
        }, 8, ["heading", "search-keyword", "error-message"])
      ])
    ]),
    _createVNode(_component_TheFooter)
  ]))
}